var userRecord = userRecode = function (opt) {

    //设置mediaSources
    var usrMediaSources = getUrlPara('mediasources');
    if(usrMediaSources){
        common.setCookie('mediasources', usrMediaSources);
    }

    var sid = getUrlPara('sid');
    if(sid){
        common.setCookie('sid', sid);
    }

    // cookie授权
    var ifCookie = common.getCookie('ifCookie');

    var options = {
        category1: '',
        category2: '',
        category3: '',
        title: '',
        module: '',
        tag: '',
        tagId: '',
        enterpriseName: '', //页面入口
        cookieId: common.getGlobalUserId(),
        equipment: client.browseInfo.equipment,
        browser: client.browseInfo.browser,
        platform: client.browseInfo.os,
        linkSource: document.referrer,
        url: location.href,
        behaviorResult: '浏览成功',
        behaviorType: '浏览网页',
        // behaviorCreatTime: '',//后端生成
        mediaSources: common.getCookie('mbMediaSource') || '',
        sid: common.getCookie('sid') || '',
        ip: client.ip,
        ifCookie: ifCookie || '是',
        client: common.isM?'手机端':'电脑端',
        linkSourceModule: getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
        utmSource: common_utmObj.utm_source,
        utmMedium: common_utmObj.utm_medium,
        utmCampaign: common_utmObj.utm_campaign,
        utmContent: common_utmObj.utm_content,
        utmTerm: common_utmObj.utm_term
    };

    //根据不同模块设置不同的配置
    options.category1 = window.cateData.userRecodeOption.category1;
    options.category2 = window.cateData.userRecodeOption.category2;
    options.category3 = window.cateData.userRecodeOption.category3;
    options.title = window.cateData.userRecodeOption.title;
    options.module = window.cateData.userRecodeOption.module;
    options.tag = window.cateData.userRecodeOption.tag;
    options.tagId = window.cateData.userRecodeOption.tagID;
    options.behaviorType = window.cateData.userRecodeOption.behaviorType;
    options.behaviorResult = window.cateData.userRecodeOption.behaviorResult;
    if (window.cateData.pageModule === 'detail') {//文章详情
        options.behaviorType = '阅读文章';
    }

    //继承方法
    var extend = function (destination, source) {
        if (!source) {
            return destination;
        }
        for (var property in source) {
            destination[property] = source[property];
        }
        return destination;
    };

    var parsOptions = extend(options, getUserInfo.options);
    parsOptions = extend(options, opt);

    var url = window.cateData.userActionUrl;

    try {
        getUserInfo.options.globalUserId =  common.getGlobalUserId(); //去除字符串中的双引号
        gio('visitor.set', {'cookieID':getUserInfo.options.globalUserId,}); //GIO 访问用户变量上传
    }catch (e) {
        console.log('gio visitor.set error', e);
    }

    try {
        var gioParams = {
            module_pvar: parsOptions.module? parsOptions.module : window.cateData.userRecodeOption.module || '',
            category1_pvar: parsOptions.category1? parsOptions.category1 : window.cateData.userRecodeOption.category1 ||'',
            category2_pvar: parsOptions.category2? parsOptions.category2 : window.cateData.userRecodeOption.category2 || '',
            category3_pvar: parsOptions.category3? parsOptions.category3 : window.cateData.userRecodeOption.category3 || '',
            title_pvar: parsOptions.title? parsOptions.title : '',
            url_pvar: parsOptions.url? parsOptions.url : '',
            mediaSources_pvar: common.getCookie('mediasources') || '',
            sid_pvar: parsOptions.sid? parsOptions.sid : '',
            linkSource_pvar: parsOptions.linkSource? parsOptions.linkSource : '',
            behaviorType_pvar: parsOptions.behaviorType? parsOptions.behaviorType : '',
            behaviorResult_pvar: parsOptions.behaviorResult? parsOptions.behaviorResult : '',
            eshop_Productnumber_cms: window.cateData.userRecodeOption.eshop_Productnumber_cms || '',

            linkSourceModule_pvar: getCookie('linkSourceModule_pvar') || '', //页面来源栏目模块（行为数据)
            linkSourceCategory1_pvar: getCookie('linkSourceCategory1_pvar') || '', //页面来源二级分类（行为数据）
            linkSourceTitle_pvar: getCookie('linkSourceTitle_pvar') || '', //页面来源title（行为数据）

            linkRecommendPosition_pvar: common.getUrlPara('recommendPosition') ? common.getUrlPara('recommendPosition') : '', //来源推荐位区域 热门文章 案例智库 您可能感兴趣 解决方案 相关资料 相关文章 产品中心 市场活动 成功案例 相关资讯 了解详情 会议活动
            productID_pvar: window.cateData.userRecodeOption.productID_pvar || '',
            linkSearchWord_pvar: common.getUrlPara('sw') ? common.getUrlPara('sw') : '',  //来源的搜索词
            contentID_pvar: window.cateData.userRecodeOption.contentID_pvar || '',
            author_pvar: window.cateData.userRecodeOption.author_pvar || '', //作者 解决方案、案例智库等带作者的页面
            tag_pvar: window.cateData.userRecodeOption.tag || '', //标签
            tagID_pvar: window.cateData.userRecodeOption.tagID || '', //标签ID

            articleId_pvar: window.cateData.userRecodeOption.articleId_pvar || '', //文章ID
            articleTitle_pvar: window.cateData.userRecodeOption.articleTitle_pvar  || '' ,
            articleType1_pvar: window.cateData.userRecodeOption.articleType1_pvar || '' ,
            articleType2_pvar: window.cateData.userRecodeOption.articleType2_pvar || '' ,
            articleType3_pvar: window.cateData.userRecodeOption.articleType3_pvar || '' ,
            productType1_pvar: window.cateData.userRecodeOption.productType1_pvar || '' ,
            productType2_pvar: window.cateData.userRecodeOption.productType2_pvar || '' ,
            productType3_pvar: window.cateData.userRecodeOption.productType3_pvar || '' ,
            productModel: window.cateData.userRecodeOption.productModel || '' ,
            companyScale_pvar: window.cateData.userRecodeOption.companyScale_pvar || '' ,
            application_pvar : window.cateData.userRecodeOption.application_pvar || '' ,
            industry_pvar: window.cateData.userRecodeOption.industry_pvar || '' ,

            webinarTitle_pvar: window.cateData.userRecodeOption.webinarTitle_pvar ||'',
            webinarType_pvar: window.cateData.userRecodeOption.webinarType_pvar || '',
            webinarOwner_pvar: window.cateData.userRecodeOption.webinarOwner_pvar || '',

            closeType_var: window.cateData.userRecodeOption.closeType_var || '',
            closeTime_var: window.cateData.userRecodeOption.closeTime_var || '',
            triggerReason_var: window.cateData.userRecodeOption.triggerReason_var || '',
        };
        if(!gioParams.module_pvar){
            try {
                gioParams['source_link'] = document.referrer;
                gioParams['client'] = client;
                gioParams['page_set_module'] = window.cateData.userRecodeOption.module;

                common.dd('gio模块值为空', JSON.stringify(gioParams));
            } catch (e) {
                console.log(e);
            }

        }
        // gioPageAction.configData();
        // gioParams = extend(gioParams, window.gioPageOptions);
        // gioParams.tag_pvar = window.cateData.userRecodeOption.tag || window.gioPageOptions.tag_pvar || '';
        // gioParams.tagID_pvar = window.cateData.userRecodeOption.tagID || window.gioPageOptions.tagID_pvar || '';
        gio('page.set', gioParams);
        // console.log(gioParams);
        gio('evar.set', {'moduleName_last_evar': gioParams.module_pvar, 'moduleName_linear_evar':gioParams.module_pvar});
        gio('evar.set', {'category1_last_evar': gioParams.category1_pvar, 'category1_linear_evar':gioParams.category1_pvar});
        gio('evar.set', {'title_linear_evar': document.title, 'title_last_evar':document.title});
        common.setCookie('linkSourceModule_pvar', gioParams.module_pvar);
        common.setCookie('linkSourceCategory1_pvar', gioParams.category1_pvar);
        common.setCookie('linkSourceTitle_pvar', gioParams.title_pvar);
    }catch (e) {
        console.log('userRecode js gio error',e);
    }

    // 未登录，并且点击拒绝授权cookie
    if (!isLogin() && ifCookie == '否') {
         return;
    }
    // 已登录，点击拒绝授权cookie,把cookieId清空
    if (isLogin() && ifCookie == '否') {
        parsOptions.cookieId = '';
        parsOptions.globalUserId = '';
    }
    if(!parsOptions.module){
        try {
            common.dd('自有用户行为模块值为空', JSON.stringify(parsOptions));
        } catch (e) {
            console.log(e);
        }
    }
    // 已登录，传递session、ocsessid
    if (common.isLogin()) {
        parsOptions.session = common.isLogin().session;
        parsOptions.OCSESSID = common.isLogin().OCSESSID;
    }

    console.log('%c_________________________________________________________','color:#02afe9;')
    console.log('栏目模块(module):',parsOptions.module)
    console.log('一级栏目(category1):',parsOptions.category1)
    console.log('二级栏目(category2):',parsOptions.category2)
    console.log('三级栏目(category3):',parsOptions.category3)
    console.log('页面标题(title):',parsOptions.title)
    console.log('%c_________________________________________________________','color:#02afe9;')

    if(location.href.indexOf('www.') > -1 || location.href.indexOf('m.') > -1) {
        // 正式环境才提交行为记录
        postJson(url, parsOptions);
    }else{
        console.log('测试环境行为记录参数，仅展示不提交', parsOptions)
    }

};

var getUserInfoDef = $.Deferred();
function getUserInfoDefDone(status, option) {
    getUserInfoDef.resolve(option, status);
}

// 用户信息获取
var getUserInfo = {
    options: {
        globalUserId: '',
        cookieId: '',
        userId: '',
        openId: '',
        unionId: '',
        email: '',
        mobile: '',
        name: '',
        areaCode: '',
        companyPhone: '',
        extension: '',
        enterpriseName: '',
        enterprise: '',
        department: '',
        position: '',
        province: '',
        address: '',
        industry: '',
        companyNum: '',
        ifWish: '',
        privacyNotice: '',
    },

    userFormData: null,

    //获取globalUserId
    globalUserId: function () {
        this.options.globalUserId = common.getGlobalUserId();
        this.getContactId();
        this.getUserId();

    },

    // 获取访问用户组别信息 0组 1组
    getUserTeam: function(){
        return 1
    },

    // 获取联系人ID
    getContactId: function () {
        var _this = this;
        //
        var contactCookieName = 'dell_contactId_' + md5(common.getGlobalUserId());

        // 从cookie中获取联系人ID
        if(common.getCookie(contactCookieName)){
            _this.options.contactId = common.getCookie(contactCookieName);
        }else{
            common.getJson(window.cateData.api.getContactIdUrl, {'cookieId': common.getGlobalUserId()}, function (data) {
                if(data.errCode === 0){
                    var contactId = data.data.contactId;
                    if(!contactId) return;
                    common.setCookie(contactCookieName, contactId, 5);
                    _this.options.contactId = contactId
                }
            });
        }
    },

    //获取用户ID
    getUserId: function () {
        var _this = this;

        if (!isLogin()) {
            _this.options = {globalUserId: _this.options.globalUserId};
            userRecode(_this.options);

            //构子函数
            getUserInfoDone(false);
            getUserInfoDefDone(false, _this.options);
            return;
        }

        var info = {
            tenantId: window.cateData.tenantId,
            sess: isLogin().session || '',
        };
        var getUrl = window.cateData.api.getUserId;

        postJson(getUrl, info, function (data) {
            if(data.body.result !== 0){
                msg.toast('登录失效，请重新登录');
                common.loginOut();
                setTimeout(function () {
                    common.gotoLogin();
                },1500);
                return;
            }
            var ids = data.body.content;

            _this.options.cookieId = ids["cookieId"] ? ids["cookieId"] : '';
            _this.options.userId = ids["loginId"] ? ids["loginId"] : '';
            _this.options.openId = ids["openId"] ? ids["openId"] : '';
            _this.options.unionId = ids["unionId"] ? ids["unionId"] : '';
            _this.getUserInfo();
        });
    },

    //获取用户信息
    getUserInfo: function () {
        var _this = this;
        var info = {
            globalUserId: common.getGlobalUserId(),
            sess: isLogin().session || '',
        };

        var getUrl = window.cateData.api.getUserInfo;
        postJson(getUrl, info, function (data) {

            if (data.body.result === 0) {
                var d2_rs = {};
                data.body.content.forEach(function (item) {
                    d2_rs[item.key] = item.value;
                });
                _this.userFormData = data.body.content;
                _this.options.email = d2_rs["email"] ? d2_rs["email"] : '';
                _this.options.avatar = d2_rs["avatar"] ? d2_rs["avatar"] : '';
                _this.options.mobile = d2_rs["mobile"] ? d2_rs["mobile"] : '';
                _this.options.name = d2_rs["name"] ? d2_rs["name"] : '';
                _this.options.areaCode = d2_rs["areacode"] ? d2_rs["areacode"] : '';
                _this.options.companyPhone = d2_rs["compphone"] ? d2_rs["compphone"] : '';
                _this.options.extension = d2_rs["ext"] ? d2_rs["ext"] : '';
                _this.options.enterpriseName = d2_rs["enterprise_name"] ? d2_rs["enterprise_name"] : '';
                _this.options.enterprise = d2_rs["enterprise"] ? d2_rs["enterprise"] : '';
                _this.options.department = d2_rs["department"] ? d2_rs["department"].toString() : "";
                _this.options.position = d2_rs["position"] ? d2_rs["position"].toString() : "";
                _this.options.province = d2_rs['province'] ? d2_rs['province'].toString() : '';
                _this.options.address = d2_rs['address'] ? d2_rs['address'] : '';
                _this.options.industry = d2_rs['industry'] ? d2_rs['industry'].toString() : '';
                _this.options.companyNum = d2_rs['employeesNumber'] ? d2_rs['employeesNumber'].toString() : '';
                _this.options.ifWish = d2_rs['ifWish'] ? d2_rs['ifWish'].toString() : '';
                _this.options.privacyNotice = d2_rs['privacynotice'] ? d2_rs['privacynotice'].toString() : '';
                _this.options.userGroup = d2_rs['userGroup'] ? d2_rs['userGroup'] : ''; // 注册信息中的分组字段
                _this.options.joblevel = d2_rs["joblevel"] ? d2_rs["joblevel"].toString() : "";
                _this.options.jobfunction = d2_rs["jobfunction"] ? d2_rs["jobfunction"].toString() : "";
                _this.options.jobfunctionrole = d2_rs["jobfunctionrole"] ? d2_rs["jobfunctionrole"].toString() : "";
                userRecode(_this.options);

                try {
                    if (setDTFNavigatorAccount && typeof setDTFNavigatorAccount == 'function') {
                        setDTFNavigatorAccount(_this.options.name);
                    }
                }catch (e) {
                    console.log(e);
                }

                //构子函数
                getUserInfoDone(true);
                getUserInfoDefDone(true, _this.options);
                //gio触发
                gio('setUserId', _this.options.userId);
                var gioParams = {
                    phone_ppl: common.mobileGioEncryption(_this.options.mobile),
                };
                gio('people.set',gioParams);
            } else {
                // 用户认证失败删除相应cookie
                delCookie('smarketMember_' + window.cateData.schemaId);
                delCookie('globalUserId');
                //构子函数
                getUserInfoDone(false);
                getUserInfoDefDone(false, _this.options);
                userRecode(_this.options);
            }
        })
    },

    // 更新用户信息
    updateUserInfo: function (afterFunc) {
        var _this = this;
        var info = {
            globalUserId: common.getGlobalUserId(),
            sess: isLogin().session || '',
        };

        var getUrl = window.cateData.api.getUserInfo;

        postJson(getUrl, info, function (data) {
            if (data.body.result === 0) {
                var d2_rs = {};
                data.body.content.forEach(function (item) {
                    d2_rs[item.key] = item.value;
                });
                _this.userFormData = data.body.content;
                _this.options.email = d2_rs["email"] ? d2_rs["email"] : '';
                _this.options.avatar = d2_rs["avatar"] ? d2_rs["avatar"] : '';
                _this.options.mobile = d2_rs["mobile"] ? d2_rs["mobile"] : '';
                _this.options.name = d2_rs["name"] ? d2_rs["name"] : '';
                _this.options.areaCode = d2_rs["areacode"] ? d2_rs["areacode"] : '';
                _this.options.companyPhone = d2_rs["compphone"] ? d2_rs["compphone"] : '';
                _this.options.extension = d2_rs["ext"] ? d2_rs["ext"] : '';
                _this.options.enterpriseName = d2_rs["enterprise_name"] ? d2_rs["enterprise_name"] : '';
                _this.options.enterprise = d2_rs["enterprise"] ? d2_rs["enterprise"] : '';
                _this.options.department = d2_rs["department"] ? d2_rs["department"].toString() : "";
                _this.options.position = d2_rs["position"] ? d2_rs["position"].toString() : "";
                _this.options.province = d2_rs['province'] ? d2_rs['province'].toString() : '';
                _this.options.address = d2_rs['address'] ? d2_rs['address'] : '';
                _this.options.industry = d2_rs['industry'] ? d2_rs['industry'].toString() : '';
                _this.options.companyNum = d2_rs['employeesNumber'] ? d2_rs['employeesNumber'].toString() : '';
                _this.options.ifWish = d2_rs['ifWish'] ? d2_rs['ifWish'].toString() : '';
                _this.options.privacyNotice = d2_rs['privacynotice'] ? d2_rs['privacynotice'].toString() : '';
                _this.options.userGroup = d2_rs['userGroup'] ? d2_rs['userGroup'] : ''; // 注册信息中的分组字段
                _this.options.joblevel = d2_rs["joblevel"] ? d2_rs["joblevel"].toString() : "";
                _this.options.jobfunction = d2_rs["jobfunction"] ? d2_rs["jobfunction"].toString() : "";
                _this.options.jobfunctionrole = d2_rs["jobfunctionrole"] ? d2_rs["jobfunctionrole"].toString() : "";

                try {
                    if (setDTFNavigatorAccount && typeof setDTFNavigatorAccount == 'function') {
                        setDTFNavigatorAccount(_this.options.name);
                    }
                    if (afterFunc && typeof afterFunc == 'function') {
                        afterFunc();
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        })
    },

    clearUserInfo: function () {
        // 循环设置this.options的值为空
        for (var key in this.options) {
            this.options[key] = ''; //清空
        }
    },

    init: function () {
        //获取globalUserId
        this.globalUserId();
    }
}


//客户端信息获取
var client = {
    ip: '',
    browser: {
        version: '',
        name: '',
    },
    browseInfo: {
        userAgent: '',
        browser: '',
        version: '',
        os: '',
        equipment: '',
        resolution: '',
        referenceUrl: '',
        referenceTitle: '',
        type: '' //pc、wap
    },
    os: {
        name: '',
    },
    screen: {
        width: window.screen.width,
        height: window.screen.height,
        resolution: window.screen.width + ' * ' + window.screen.height,
    },

    getBrowseInfo: function () {
        var ua, liulanqi, banben, os, equipment, isEdge, isSafari, isChrome, isFirefox, isOpera, isIE, isBrowser,
            isAndroid, isWe,isXcxWebview, isIPhones, isIPad, isVersion, isWeChat;
        ua = navigator.userAgent;
        liulanqi = '';
        banben = '';
        os = '';
        equipment = '';
        isEdge = ua.match(/(Edge)\/([\d.]+)/i);
        isSafari = ua.match(/Version\/([\d.]+)\s+?(Safari)/i);
        isChrome = ua.match(/(Chrome)\/([\d.]+)/i);
        isFirefox = ua.match(/(Firefox)\/([\d.]+)/i);
        isOpera = ua.match(/(OPR|OPERA).+?([\d.]+)/i);
        isIE = ua.indexOf('Trident') > -1 ||
            ua.toLocaleLowerCase().indexOf('msie') > -1;
        isBrowser = ua.match(/(\w+Browser)[^\d]+?([\d.]+)/i) ||
            ua.match(/\d\s+?([^\d]+)([\d.]+)$/i);
        isAndroid = ua.match(/(Android[\s\d.]+);.+?([^;]+)Build/i);
        isWe = ua.match(/MicroMessenger.+?([\d.]+)/i);
        isXcxWebview = ua.indexOf('miniProgram') > -1;
        isIPhones = ua.match(/CPU([\s\w\d_]+)like/i);
        isIPad = ua.match(/iPad/i) ? 'iPad' : 'iPhone';
        isVersion = ua.match(/Version\/([\d.]+)/i);
        isWeChat = isWe;

        //如果是移动端
        if (!!ua.match(/AppleWebKit.*Mobile.*/)) {
            if (isXcxWebview) {
                liulanqi = '小程序Webview';
                banben = 'v1.0';
            }else if (isWe) {
                liulanqi = '微信';
                banben = isWe[1];
            } else {
                if (isBrowser) {
                    liulanqi = isBrowser[1];
                    banben = isBrowser[2];
                    if (liulanqi.indexOf('Browser') === -1 && isVersion) {
                        banben = isVersion[1];
                    }
                } else {
                    liulanqi = '手持设备浏览器';
                    banben = '未知';
                }
            }
            if (isAndroid) {
                os = isAndroid[1];
                equipment = isAndroid[2];
            } else {
                if (isIPhones) {
                    os = isIPhones[1];
                } else {
                    os = isIPad;
                }
                equipment = isIPad;
            }
            this.browseInfo.type = 'wap';
        } else {
            if (isSafari) {
                liulanqi = isSafari[2];
                banben = isSafari[1];
            }
            if (isChrome) {
                liulanqi = isChrome[1];
                banben = isChrome[2];
            }
            if (isFirefox) {
                liulanqi = isFirefox[1];
                banben = isFirefox[2];
            }
            if (isEdge) {
                liulanqi = isEdge[1];
                banben = isEdge[2];
            }
            if (isOpera) {
                liulanqi = 'OPERA';
                banben = isOpera[2];
            }

            if (isIE) {
                liulanqi = 'IE';
                var isIEV01 = ua.match(/(MSIE).+?(\d+)/i);
                var isIEV02 = ua.match(/(rv).+?(\d+)/i);
                if (isIEV01) {
                    banben = isIEV01[2];
                }
                if (isIEV02) {
                    banben = isIEV02[2];
                }
            }
            os = ua.match(/windows/i) ? 'Windows' : 'Mac OS';
            equipment = '电脑端';
            this.browseInfo.type = 'pc';
        }
        this.browseInfo.userAgent = ua;
        this.browseInfo.browser = liulanqi;
        this.browseInfo.version = banben;
        this.browseInfo.os = os;
        this.browseInfo.equipment = equipment;
        this.browseInfo.resolution = window.screen.width + 'X' + window.screen.height;
        this.browseInfo.referenceUrl = document.referrer || '';
        this.browseInfo.referenceTitle = '';
    },

    getIp: function () {
        var _this = this;
        $.getScript('//s2-api.smarket.net.cn/cityjson').done(function (data) {
            _this.ip = returnCitySN.cip;
            getUserInfo.init();
        });
    },

    init: function () {
        this.getIp();
        this.getBrowseInfo();
    }
};

//行为记录
var userAction = {
    title: window.cateData.userRecodeOption.title,
    // 登录成功
    login: function () {
        userRecord({'behaviorType':'登录', 'behaviorResult':'登录成功'})
    },
    // 登录失败
    loginFail: function () {
        userRecord({'behaviorType':'登录', 'behaviorResult':'登录失败'})
    },
    // 退出登录
    logOut:function () {
        userRecord({'behaviorType':'退出登录', 'behaviorResult':'退出成功'})
    },
    // 注册
    register: function (name) {
        userRecord({'behaviorType':'注册', 'behaviorResult':name})
    },
    // 搜索
    search: function (name) {
        userRecord({'behaviorType':'搜索', 'behaviorResult':name})
    },
    // 在线客服点击
    onlineCustomer: function (name) {
        name = name ? name : this.title;
        userRecord({'behaviorType':'在线客服点击', 'behaviorResult':name})
    },
    // 400点击
    customerPhone: function (name) {
        name = name ? name : this.title;
        userRecord({'behaviorType':'400点击', 'behaviorResult':name})
    },
    // 项目咨询点击
    productConsultationClick: function (name) {
        name = name ? name : this.title;
        userRecord({'behaviorType':'项目咨询点击', 'behaviorResult':name})
    },
    // 加入购物车
    addCart: function (name) {
        userRecord({'behaviorType':'加入采购清单', 'behaviorResult':name + ' 加入采购清单'});
    },
    // 加入收藏
    addFavorites: function (name) {
        userRecord({'behaviorType':'收藏', 'behaviorResult':name});
    },
    // 取消收藏
    removeFavorites: function (name) {
        userRecord({'behaviorType':'取消收藏', 'behaviorResult':name});
    },
    // 预览
    preview: function (name) {
        userRecord({'behaviorType':'预览', 'behaviorResult':name});
    },
    // 下载
    download: function (name) {
        userRecord({'behaviorType':'下载', 'behaviorResult':name});
    },
    // 观看视频
    playVideo: function (name) {
        name = name ? name : this.title;
        userRecord({'behaviorType':'观看视频', 'behaviorResult':name});
    },
    // 评论
    comment: function (name) {
        userRecord({'behaviorType':'评论', 'behaviorResult':name});
    },
    // 删除评论
    delComment: function (name) {
        userRecord({'behaviorType':'删除评论', 'behaviorResult':name});
    },
    // 评论点赞
    likeComment: function (name) {
        userRecord({'behaviorType':'评论点赞', 'behaviorResult':name});
    },
    // 取消评论点赞
    cancelLikeComment: function (name) {
        userRecord({'behaviorType':'取消评论点赞', 'behaviorResult':name});
    },
    // 播放产品视频
    playProductVideo: function () {
        userRecord({'behaviorType':'播放产品视频', 'behaviorResult':'播放成功'});
    },
    // 筛选文件
    filterFiles: function (name) {
        userRecord({'behaviorType':'筛选文件', 'behaviorResult':name});
    },
    // 筛选视频
    filterVideos: function (name) {
        userRecord({'behaviorType':'筛选视频', 'behaviorResult':name});
    },
    // 排序
    sort: function (name) {
        userRecord({'behaviorType':'排序', 'behaviorResult':name});
    },
    // 关注
    focusAuthor: function (name) {
        userRecord({'behaviorType':'关注', 'behaviorResult':name});
    },
    // 取消关注
    cancelFocusAuthor: function (name) {
        userRecord({'behaviorType':'取消关注', 'behaviorResult':name});
    },
    // 分享
    share: function (name) {
        userRecord({'behaviorType':'分享', 'behaviorResult':name});
    },
    // 分享卡片弹窗-复制链接
    shareCopyUrl: function (name) {
        userRecord({'behaviorType':'分享卡片弹窗-复制链接', 'behaviorResult':name});
    },
    // 分享卡片弹窗-保存
    shareSave: function (name) {
        userRecord({'behaviorType':'分享卡片弹窗-保存', 'behaviorResult':name});
    },
    // 分享卡片弹窗-关闭
    shareClose: function (name) {
        userRecord({'behaviorType':'分享卡片弹窗-关闭', 'behaviorResult':name});
    },
    // 跳转至商品详情
    goShopDetail: function (name) {
        userRecord({'behaviorType':'跳转至商品详情', 'behaviorResult':name});
    },
    // 观看回放
    watchReplay: function (name) {
        userRecord({'behaviorType':'观看回放', 'behaviorResult': this.title + name});
    },
    // 会议报名
    meetingSignUp: function (name) {
        userRecord({'behaviorType':'会议报名', 'behaviorResult': this.title + name});
    },
    // 进入会场
    enterMeetingRoom: function (name) {
        userRecord({'behaviorType':'进入会场', 'behaviorResult': this.title + name});
    },
    // 直播间-发送提问
    sendQuestion: function (name) {
        userRecord({'behaviorType':'直播间-发送提问', 'behaviorResult':name});
    },
    // 直播间-填写问卷
    fillInQuestionnaire: function () {
        userRecord({'behaviorType':'直播间-填写问卷', 'behaviorResult': this.title});
    },
    // 直播间-关闭问卷
    closeQuestionnaire: function () {
        userRecord({'behaviorType':'直播间-关闭问卷', 'behaviorResult': this.title + '关闭问卷'});
    },
    // 直播间-填写投票
    fillInPoll: function () {
        userRecord({'behaviorType':'直播间-填写投票', 'behaviorResult': this.title});
    },
    // 直播间-关闭投票
    closePoll: function () {
        userRecord({'behaviorType':'直播间-关闭投票', 'behaviorResult': this.title + '关闭投票'});
    },
    // 直播间-抽奖
    lotteryInLiveRoom: function () {
        userRecord({'behaviorType':'直播间-抽奖', 'behaviorResult': this.title});
    },
    // 直播间-关闭抽奖
    closeLotteryInLiveRoom: function () {
        userRecord({'behaviorType':'直播间-关闭抽奖', 'behaviorResult': this.title + '关闭抽奖展示'});
    },
    // 直播间-弹幕切换
    switchBarrage: function (name) {
        userRecord({'behaviorType':'直播间-弹幕切换', 'behaviorResult':name});
    },
    // 直播间-会议点赞
    likeMeeting: function () {
        userRecord({'behaviorType':'直播间-会议点赞', 'behaviorResult': this.title + '会议点赞'});
    },
    // 直播间-马上抢
    rushInLiveRoom: function (name) {
        userRecord({'behaviorType':'直播间-马上抢', 'behaviorResult': this.title + name});
    },
    // 企业级精品课-进入课程
    enterCourseInEnterpriseClass: function (name) {
        userRecord({'behaviorType':'企业级精品课-进入课程', 'behaviorResult':name});
    },
    // 确认修改信息
    modifyPpersonalInformation: function (name) {
        userRecord({'behaviorType':'确认修改信息', 'behaviorResult':name});
    },
    // 修改密码
    changePassword: function (name) {
        userRecord({'behaviorType':'修改密码', 'behaviorResult':name});
    },

    // 兴趣标签选择
    interestTagSelect: function (tags) {
        userRecord({'behaviorType':'选择用户标签', 'behaviorResult': tags});
    },

    // 侧边导航点击
    navView: function (name) {
        userRecord({'behaviorType':'查看导航', 'behaviorResult':name});
    },

    // 点击商品筛选参数时记录
    filterProduct: function (options) {
        userRecord({'behaviorType':'筛选商品参数', 'behaviorResult':options});
    },
};
window.userAction = userAction;
